import AlertBannerWrapper from "../components/AlertBannerWrapper/AlertBannerWrapper";
import AlertCloseButton from "../components/AlertCloseButton/AlertCloseButton";
import AlertMessage from "../components/AlertMessage/AlertMessage";
const AlertBannerCommunication = ({
  visible,
  children,
  onClick,
  visibleButton,
}) => {
  return (
    <AlertBannerWrapper backgroundColor={"#008b8b"} visible={visible}>
      <AlertMessage>{children}</AlertMessage>
      <AlertCloseButton
        onClick={onClick}
        iconStyle={{
          fill: "#008b8b",
          stroke: "#008b8b",
        }}
        visibleButton={visibleButton}
      ></AlertCloseButton>
    </AlertBannerWrapper>
  );
};
AlertBannerCommunication.defaultProps = {
  visible: true,
  onClick: () => {},
};

export default AlertBannerCommunication;
